import styled from 'styled-components';
import { Compose, ComposeType, StyledDiv } from '../../../Theme/CommonStyled';

export const StyledSelectContainer = styled(StyledDiv)`
  position: relative;

  i {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    pointer-events: none;
  }
`;

export const StyledSelect = styled.select<ComposeType>`
  display: flex;
  text-align: center;
  text-align: -webkit-center;
  text-align: -moz-center;
  text-align-last: center;
  border: none;
  outline: none;
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  border-radius: ${({ theme }): string => theme.radii.xl};
  font-size: ${({ theme }): string => theme.fontSizes[6]};
  color: ${({ theme }): string => theme.colors.normalText};
  padding: 15px;
  padding-left: 28px;
  direction: rtl;
  width: 100%;
  line-height: 20px;
  justify-content: center;
  align-items: center;

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  ${Compose};

  option {
    padding-left: 100px;
    background-color: #f2f2f2;
    color: #333;
  }
`;
